<script setup>

import LandingPageNavBarV2 from '@/components/navigation/LandingPageNavigationBarV2.vue';
import Footer from '@/components/landing/Footer.vue';
import SharedBackground from '@/components/layout/SharedBackground.vue';
import {
  ref, provide, onMounted, onUnmounted,
} from 'vue';

const activeSection = ref('');
provide('activeSection', activeSection);

let observer;

onMounted(() => {
  const sections = document.querySelectorAll('section[id]');
  observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          activeSection.value = entry.target.id;
        }
      });
    },
    {
      threshold: 0.1,
      rootMargin: '0px 0px -30% 0px',
    },
  );

  sections.forEach((section) => observer.observe(section));
});

onUnmounted(() => {
  if (observer) observer.disconnect();
});
</script>

<template>
  <div class="relative min-h-screen overflow-hidden">
    <SharedBackground />

    <!-- Content -->
    <div class="relative z-10">
      <LandingPageNavBarV2 />
      <RouterView />
      <!-- <Footer /> -->
    </div>
  </div>
</template>

<style scoped></style>
